
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanStatus } from 'enums/AccountingPlanStatus';
import { AccountingPlanSetupModel } from './Entities.Accounting.AccountingPlanSetup';
import { LedgerPostModel } from './Entities.Accounting.LedgerPost';
import { RevenueRegistrationModel } from './Entities.Accounting.RevenueRegistration';
import { Model, ModelProperty } from 'models/Model';


export class AccountingPlanModel extends Model<AccountingPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'status', type: 'AccountingPlanStatus' },
		{ name: 'systemStart', type: 'Date' },
		{ name: 'systemEnd', type: 'Date' },
		{ name: 'totalPlanValue', type: 'number' },
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'startUpDeliveryDate', type: 'Date' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'paymentInterval', type: 'number' },
		{ name: 'accountingPlanSetupId', type: 'string' },
		{ name: 'salesTypeDimension', type: 'string' },
		{ name: 'departmentDimension', type: 'string' },
		{ name: 'companyDimension', type: 'string' },
		{ name: 'startupAmount', type: 'number' },
		{ name: 'startupInstallments', type: 'number' },
		{ name: 'pausedRegistrations', type: 'Date' },
		{ name: 'completedRegistrations', type: 'Date' },
		{ name: 'subscriptionNo', type: 'string' },
		{ name: 'suspended', type: 'Date' },
		{ name: 'systemConverted', type: 'boolean' },
		{ name: 'supersedesAccountingPlanId', type: 'string' },
		{ name: 'ignorePriceAdjustments', type: 'boolean' },
		{ name: 'referenceNo', type: 'number' },
		{ name: 'latestAnnualPriceAdjustment', type: 'Date' },
		{ name: 'companyId', type: 'string' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'string' },
		{ name: 'numberOfInstallments', type: 'number' },
		{ name: 'autoRenewedFromAccountingPlanId', type: 'string' },
		{ name: 'deleted', type: 'boolean', isHidden: true },
		{ name: 'brandId', type: 'string' },
		{ name: 'accountingPlanSetup', type: 'AccountingPlanSetupModel', isHidden: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'inverseSupersedesAccountingPlan', type: 'AccountingPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'ledgerPosts', type: 'LedgerPostModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new LedgerPostModel }, properties: () => { return LedgerPostModel.classProperties } },
		{ name: 'revenueRegistrations', type: 'RevenueRegistrationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new RevenueRegistrationModel }, properties: () => { return RevenueRegistrationModel.classProperties } },
		{ name: 'supersedesAccountingPlan', type: 'AccountingPlanModel', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public status: AccountingPlanStatus;
	public systemStart?: Date;
	public systemEnd?: Date;
	public totalPlanValue: number;
	public id?: string;
	public productPlanId?: string;
	public startUpDeliveryDate?: Date;
	public startDate?: Date;
	public endDate?: Date;
	public paymentInterval?: number;
	public accountingPlanSetupId?: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public startupAmount?: number;
	public startupInstallments?: number;
	public pausedRegistrations?: Date;
	public completedRegistrations?: Date;
	public subscriptionNo: string;
	public suspended?: Date;
	public systemConverted?: boolean;
	public supersedesAccountingPlanId?: string;
	public ignorePriceAdjustments: boolean;
	public referenceNo: number;
	public latestAnnualPriceAdjustment?: Date;
	public companyId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public numberOfInstallments?: number;
	public autoRenewedFromAccountingPlanId?: string;
	public deleted: boolean;
	public brandId?: string;
	public accountingPlanSetup?: AccountingPlanSetupModel;
	public inverseSupersedesAccountingPlan: AccountingPlanModel[];
	public ledgerPosts: LedgerPostModel[];
	public revenueRegistrations: RevenueRegistrationModel[];
	public supersedesAccountingPlan?: AccountingPlanModel;
    
	constructor(){
		super();
		this.status = 0;
		this.systemStart = undefined;
		this.systemEnd = undefined;
		this.totalPlanValue = 0;
		this.id = undefined;
		this.productPlanId = undefined;
		this.startUpDeliveryDate = undefined;
		this.startDate = undefined;
		this.endDate = undefined;
		this.paymentInterval = undefined;
		this.accountingPlanSetupId = undefined;
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.pausedRegistrations = undefined;
		this.completedRegistrations = undefined;
		this.subscriptionNo = '';
		this.suspended = undefined;
		this.systemConverted = undefined;
		this.supersedesAccountingPlanId = undefined;
		this.ignorePriceAdjustments = false;
		this.referenceNo = 0;
		this.latestAnnualPriceAdjustment = undefined;
		this.companyId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.numberOfInstallments = undefined;
		this.autoRenewedFromAccountingPlanId = undefined;
		this.deleted = false;
		this.brandId = undefined;
		this.accountingPlanSetup = undefined;
		this.inverseSupersedesAccountingPlan = [];
		this.ledgerPosts = [];
		this.revenueRegistrations = [];
		this.supersedesAccountingPlan = undefined;
		
	}
	getProperties(){
		return AccountingPlanModel.classProperties;
	}
}

